import { Lvl1Svg, Lvl2Svg, Lvl3Svg, Lvl4Svg } from "assets/images";
import { useDeviceSize } from "hooks/useIsMobile";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import {
  LeaderBoardType,
  leaderBoardTypes,
  translationKeyForLeaderBoard
} from "../../models/LeaderBoardType";
import { StudentOrTeacherTab } from "../StudentOrTeacherTab/StudentOrTeacherTab";
import "./LeaderBoardTabs.scss";

export const LeaderboardTabs: FC = (props) => {
  const { t } = useTranslation();
  const { isMobile } = useDeviceSize();

  const [tabIndex, setTabIndex] = useState(0);

  const getClassForIndex = (index: number) => {
    switch (index) {
      case LeaderBoardType.BASIC:
        return "TabPanelBasic";
      case LeaderBoardType.ADVANCED:
        return "TabPanelAdvanced";
      case LeaderBoardType.EXPERT:
        return "TabPanelExpert";
      case LeaderBoardType.GENIUS:
        return "TabPanelGenius";
      default:
        return "TabPanelBasic";
    }
  };

  const getClassForSelectedTab = (index: number) => {
    if (index === tabIndex) {
      return `SelectedTabPanel ${getClassForIndex(tabIndex)}`;
    }
    return "";
  };

  const onSelectTab = (index: number) => {
    setTabIndex(index);
  };

  const getTabForMobile = (leaderBoardType: LeaderBoardType) => {
    switch (leaderBoardType) {
      case LeaderBoardType.BASIC:
        return <Lvl1Svg />;
      case LeaderBoardType.ADVANCED:
        return <Lvl2Svg />;
      case LeaderBoardType.EXPERT:
        return <Lvl3Svg />;
      case LeaderBoardType.GENIUS:
        return <Lvl4Svg />;
    }
  };

  return (
    <Tabs className="TabList" selectedIndex={tabIndex} onSelect={onSelectTab}>
      <TabList>
        {leaderBoardTypes.map((leaderBoardType) => (
          <Tab
            key={leaderBoardType}
            className={`Tab ${getClassForIndex(leaderBoardType)}`}
          >{isMobile 
            ? getTabForMobile(leaderBoardType)
            : <>{t(translationKeyForLeaderBoard(leaderBoardType))}</>
          }
          </Tab>
        ))}
      </TabList>
      {leaderBoardTypes.map((leaderBoardType) => (
        <TabPanel
          key={leaderBoardType}
          className={getClassForSelectedTab(leaderBoardType)}
        >
          <div className="TabContentContainer">
            <StudentOrTeacherTab leaderBoardType={tabIndex} />
          </div>
        </TabPanel>
      ))}
    </Tabs>
  );
};
